module.exports = __webpack_public_path__ + "assets/details-europe.68bf4a30.svg";